module.exports = {
  pathPrefix: '/',
  siteMetadata: {
    title: 'A Race Athlete Blog', // Site title.
    subDomain: 'blog',
    // disqusShortname: '', // Disqus shortname.
    postDefaultCategoryID: 'Cycling', // Default category for posts.
    // userName: 'Material User', // Username to display in the author segment.
    // userLocation: 'city, country', // User location to display in the author segment.
    // userAvatar: 'https://api.adorable.io/avatars/150/test.png', // User avatar to display in the author segment.
    // userDescription: "some info", // User description to display in the author segment.
    // Links to social profiles/projects you want to display in the author segment/navigation bar.
    userLinks: [
      {
        label: 'Website',
        url: '//blog.araceathlete.com',
        iconClassName: 'fa fa-link',
      },
      {
        label: 'Twitter',
        url: '//twitter.com/araceathlete',
        iconClassName: 'fa fa-twitter',
      },
      // {
      //   label: 'GitHub',
      //   url: '//github.com.local/USER',
      //   iconClassName: 'fa fa-github',
      // },
      // {
      //   label: 'Instagram',
      //   url: '//instagram.local/USER',
      //   iconClassName: 'fa fa-instagram',
      // },
      // {
      //   label: 'Facebook',
      //   url: '//facebook.com.local/USER',
      //   iconClassName: 'fa fa-facebook',
      // },
      // {
      //   label: 'Enail',
      //   url: 'mailto:gmail.com.local/USER',
      //   iconClassName: 'fa fa-envelope',
      // },
    ],
    copyright: 'Copyright © 2018. A Race athlete', // Copyright string in the footer of the website.
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    'gatsby-remark-copy-linked-files',
    'gatsby-transformer-sharp',
    'gatsby-plugin-sharp',
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'pages',
        path: `${__dirname}/src/pages/blog-posts`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'images',
        path: `${__dirname}/src/pages/blog-posts/images`,
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          {
            resolve: 'gatsby-remark-images',
            options: {
              maxWidth: 690,
            },
          },
          {
            resolve: 'gatsby-remark-responsive-iframe',
          },
          'gatsby-remark-prismjs',
          'gatsby-remark-copy-linked-files',
          'gatsby-remark-smartypants',
        ],
      },
    },
    {
      resolve: 'gatsby-plugin-google-analytics',
      options: {
        trackingId: 'UA-47311644-4',
      },
    },
    'gatsby-plugin-sharp',
    'gatsby-plugin-catch-links',
    {
      resolve: 'gatsby-plugin-favicon',
      options: {
        logo: './src/favicon.png',
        injectHTML: true,
        icons: {
          android: true,
          appleIcon: true,
          appleStartup: true,
          coast: false,
          favicons: true,
          firefox: true,
          twitter: false,
          yandex: false,
          windows: false,
        },
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./gatsby-config.js